/**
 * Creates mutually exclusive union (one or the other, not both).
 *
 * Ensures only properties from one type can be present at a time.
 * Similar to Result<T> pattern for discriminated unions.
 *
 * @example
 * ```ts
 * type BinaryPdf = { source: File; page: undefined }
 * type PlottedPdf = { source: undefined; page: Page }
 * type SinglePagePdf = XOR<BinaryPdf, PlottedPdf>
 * // Can have source OR page, but not both
 * ```
 */
export type XOR<T, U> =
  | ({ [K in Exclude<keyof T, keyof U>]?: never } & U)
  | ({ [K in Exclude<keyof U, keyof T>]?: never } & T)
